import React, { FC, useCallback, useRef } from 'react'
import { Tooltip } from 'antd'
import { FileTextOutlined } from '@ant-design/icons'
import Button from 'UI/Button/Button'
import axios from 'services/axios'
import useCustomMessage from 'hooks/useCustomMessage'
import { PLAYBOOK_CONFIG } from './playbookConfig'

interface DownloadPlaybookButtonProps {
  verticalId: string
}

const DownloadPlaybookButton: FC<DownloadPlaybookButtonProps> = ({ verticalId }) => {
  const { openMessage, contextHolder } = useCustomMessage()
  const linkRef = useRef<HTMLAnchorElement>(null)

  const config = PLAYBOOK_CONFIG[verticalId]

  const handleDownload = useCallback(async () => {
    if (!config) return

    try {
      const response = await axios.get(`playbooks/${encodeURIComponent(config.filename)}`, {
        responseType: 'blob',
        skipKeysConversion: true,
      })

      const blob = new Blob([response.data], { type: 'application/pdf' })
      if (blob.size === 0) {
        throw new Error('Downloaded file is empty')
      }

      const url = window.URL.createObjectURL(blob)

      if (linkRef.current) {
        linkRef.current.href = url
        linkRef.current.download = config.filename
        linkRef.current.click()
        window.URL.revokeObjectURL(url)
      }
    } catch {
      openMessage('error', 'Failed to download playbook. Please try again later.')
    }
  }, [config, openMessage])

  if (!config) return null

  return (
    <>
      {contextHolder}
      <Tooltip title='Download the investigation guide for this vertical'>
        <span>
          <Button buttonType='primary' onClick={handleDownload}>
            <FileTextOutlined />
            Download Playbook
          </Button>
        </span>
      </Tooltip>
      <a ref={linkRef} style={{ display: 'none' }} aria-hidden='true' />
    </>
  )
}

export default DownloadPlaybookButton
